import dataQuery from './dataQuery'
import Decimal from 'decimal.js'
import { read, utils } from 'xlsx'

export default {
  data() {
    return {
      queryDto: {
        djh: '',
        hrdwmc: '',
        pzbs: '0',
        jbr: '',
        limit: 50,
        gs: '0', //公司：0-全部，1-工程公司，2-检维修公司
        currentPage: 1
      },
      total: 0,
      voucherArr: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '未生成'
        },
        {
          value: '1',
          label: '已生成'
        }
      ],
      tableData: [],
      viewTemplate: {
        display: false,
        title: '',
        dxJe: '零',
        costTotalJe: '',
        invoiceTotalSe: '',
        invoiceTotalFpJe: '',
        userArr: [],
        costBillArr: [], //费用报销单
        serviceStationArr: [], //服务站
        subjectArr: [], //科目
        customerArr: [], //客户
        slArr: [
          { value: '0', label: '0%' },
          { value: '1', label: '1%' },
          { value: '5', label: '3%' },
          { value: '6', label: '5%' },
          { value: '2', label: '6%' },
          { value: '7', label: '7%' },
          { value: '3', label: '9%' },
          { value: '4', label: '13%' }
        ], //税率
        settlementMethodArr: [ //税率
          { value: '承兑支付', label: '承兑支付' },
          { value: '现金支付', label: '现金支付' }
        ],
        cost: [], // 分摊成本 子表
        invoice: [], // 增值税发票 子表
        creditEntry: [], // 贷方分录 子表
        data: { // 主表数据
          modedatacreatedate: dataQuery.dateToString(new Date()),
          jbr: localStorage.getItem('userName'),
          pzbs: '0'
        }
      },
      saveUrl: '',
      bookkeepingCompany: [
        { label: '供应商', options: [] },
        { label: '客户', options: [] }
      ],
      jurisdiction: '',
      view: 'view',
      accountingView: 'view',
      btnShow: [true, false, false, false],
      customerDto: {
        customerTable: [],
        display: false,
        name: '',
        limit: 50,
        currentPage: 1,
        total: 0,
        dfIndex: ''
      },
      fileList: []

    }
  },

  created() {
    dataQuery.setThis(this)
    dataQuery.costUser()
    dataQuery.customer().then(res => {
      this.customerDto.total = this.viewTemplate.customerArr.length
      this.queryCustomerTable()
    })
    this.jurisdiction = dataQuery.getJurisdiction()
    if (this.jurisdiction === 'bill') {
      dataQuery.serviceStation(localStorage.getItem('userNo'))
      dataQuery.subject(localStorage.getItem('userNo'))
      this.btnShow = [true, true, true, false]
    } else if (this.jurisdiction === 'account') {
      this.btnShow = [true, true, false, true]
    }
    if (localStorage.getItem('userNo') === '50559') {
      this.queryDto.gs = '1'
    } else if (localStorage.getItem('userNo') === '52164') {
      this.queryDto.gs = '2'
    }
    this.queryBillData()
  },
  methods: {
    /* 每页多少条 */
    handleSizeChange(size) {
      this.queryDto.limit = size
      this.queryBillData()
    },
    // 调制 第几页
    handleCurrentChange(currentpage) {
      this.queryDto.currentPage = currentpage
      this.queryBillData()
    },
    queryCustomerTable() {
      const size = this.customerDto.limit
      const page = this.customerDto.currentPage - 1
      const name = this.customerDto.name
      this.customerDto.customerTable.length = 0
      let allData = []
      if (name !== '') {
        allData = this.viewTemplate.customerArr.filter(val => val.name.indexOf(name) !== -1)
        this.customerDto.total = allData.length
      } else {
        allData = this.viewTemplate.customerArr
      }

      for (let i = page * size; i < page * size + size; i++) {
        if (i < allData.length) {
          this.customerDto.customerTable.push(allData[i])
        }
      }

    },
    /* 每页多少条 */
    customerSizeChange(size) {
      this.customerDto.limit = size
      this.queryCustomerTable()
    },
    // 调制 第几页
    customerCurrentChange(currentpage) {
      this.customerDto.currentPage = currentpage
      this.queryCustomerTable()
    },
    khClick(scope) {
      this.customerDto.dfIndex = scope.$index
      this.customerDto.display = true
    },
    khTableRowClick(row, column, event) {
      if (this.customerDto.dfIndex !== '') {
        const index = this.customerDto.dfIndex
        this.$set(this.viewTemplate.creditEntry[index], 'khName', row.name)
        this.$set(this.viewTemplate.creditEntry[index], 'kh', row.code)
        this.customerDto.display = false
      }
    },
    queryDtoChange() {
      this.queryDto.limit = 50
      this.queryDto.currentPage = 1
    },
    queryBillData() {
      const loading = this.$loading({
        lock: true,
        text: '查询中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$post('/fesback/paymentCost/list.z', this.queryDto).then(res => {
        if (res.data) {
          this.tableData = res.data.data
          this.total = res.data.count
        }
        loading.close()
      }).catch(res => {
        this.$message.error(res)
        loading.close()
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.bookkeepingCompany[0].options = []
        this.bookkeepingCompany[1].options = []
        const data = {
          subjectName: query
        }
        this.$post('/fesback/fksqd/getFksqdGys.z', data).then(response => {
          if (response !== undefined && response.length > 0) {
            const kh = response.filter(item => item.typeCode !== null)
            const gys = response.filter(item => item.typeCode === null)
            this.bookkeepingCompany[1].options = kh
            this.bookkeepingCompany[0].options = gys
          }
        })
      } else {
        this.bookkeepingCompany[0].options = []
        this.bookkeepingCompany[1].options = []
      }
    },
    changecwjzdw(event) {
      this.viewTemplate.data.hrdwmc = event.subjectName
      this.viewTemplate.data.cwjzdw = event.subjectCode
    },
    add() {
      this.view = 'edit'
      this.saveUrl = '/fesback/paymentCost/savePayment.z'
      this.openViewInitData()
    },
    editView(row, view) {
      this.openViewInitData()
      this.view = view
      let gsbs = '0'
      if (this.jurisdiction === 'account' && view === 'edit') {
        this.accountingView = 'edit'
        gsbs = '1'
      } else {
        this.accountingView = 'view'
        if (view === 'view') {
          gsbs = '1'
        }
      }
      this.$post('/fesback/paymentCost/findById.z', { id: row.id, gs: row.gs, gsbs: gsbs }).then(res => {
        if (res.data) {
          if (res.data.subject && res.data.subject.length > 0) {
            this.viewTemplate.subjectArr = res.data.subject
          }
          if (res.data.title) {
            this.viewTemplate.title = res.data.title
          }
          if (res.data.serviceStation && res.data.serviceStation.length > 0) {
            this.viewTemplate.serviceStationArr = res.data.serviceStation
          }
          if (res.data.payment) {
            this.viewTemplate.data = res.data.payment
            const ry = this.viewTemplate.data.ry
            this.viewTemplate.dxJe = dataQuery.convertCurrency(this.viewTemplate.data.je)
            if (view === 'view' && ry) {
              this.viewTemplate.data.ry = this.viewTemplate.userArr.filter(item => item.code === ry)[0].name
            }
          }

          this.viewTemplate.cost = res.data.order ? res.data.order : []
          this.viewTemplate.invoice = res.data.invoice ? res.data.invoice : []
          this.viewTemplate.creditEntry = res.data.credit ? res.data.credit : []
          this.viewTemplate.creditEntry.forEach(value => {
            if (value.kh) {
              this.$post('/fesback/dataQuery/customer.z', { code: value.kh }).then(res => {
                if (res.data) {
                  this.$set(value, 'khName', res.data[0].name)
                }
              })
            }
          })
          if (view === 'view') {
            this.viewTemplate.cost.forEach(value => {
              const fwzList = this.viewTemplate.serviceStationArr.filter(item => item.code === value.fwz)
              if (fwzList && fwzList.length > 0) {
                value.fwz = fwzList[0].name
              }
              const kmList = this.viewTemplate.subjectArr.filter(item => item.code === value.kmbm)
              if (kmList && kmList.length > 0) {
                value.kmbm = kmList[0].name
              }
            })
            this.viewTemplate.invoice.forEach(value => {
              value.sl = this.viewTemplate.slArr.filter(item => item.value === value.sl)[0].label
            })
          }
          if (this.accountingView === 'view') {
            this.viewTemplate.creditEntry.forEach(value => {
              const kmlList = this.viewTemplate.subjectArr.filter(item => item.code === value.km)
              if (kmlList && kmlList.length > 0) {
                value.km = kmlList[0].name
              }
            })
          }
          this.saveUrl = '/fesback/paymentCost/editPayment.z'
        }
      })
    },
    openViewInitData() {
      this.viewTemplate.data = { // 主表数据
        modedatacreatedate: dataQuery.dateToString(new Date()),
        jbr: localStorage.getItem('userName'),
        pzbs: '0'
      }
      this.viewTemplate.cost = []
      this.viewTemplate.invoice = []
      this.viewTemplate.creditEntry = []
      this.viewTemplate.costTotalJe = ''
      this.viewTemplate.dxJe = '零'
      this.viewTemplate.invoiceTotalSe = ''
      this.viewTemplate.invoiceTotalFpJe = ''
      dataQuery.queryCostBill(this.viewTemplate.data.jkrxm)
      this.viewTemplate.display = true
    },
    delData(row) {
      this.$confirm('确认删除单据号：' + row.djh + ' 单据数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post('/fesback/paymentCost/delPayment.z', { id: row.id }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.queryBillData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => { this.$message.info('已取消删除') })
    },
    generateVoucher(row) {
      console.log(row)
      const loading = this.$loading({
        lock: true,
        text: '查询中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$post('/fesback/financeInfo/paymentVoucher.z', { djh: row.djh, jbr: row.jbr }).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.queryBillData()
        } else {
          this.$message.error(res.message)
        }
        loading.close()
      })
    },
    jeChange() {
      if (this.viewTemplate.data.je === '') {
        this.viewTemplate.data.je = '0'
      }
      this.viewTemplate.dxJe = dataQuery.convertCurrency(this.viewTemplate.data.je)
    },
    getCostSummaries() {
      return dataQuery.getCostSummaries()
    },
    getInvoiceSummaries() {
      let je = 0
      let se = 0
      this.viewTemplate.invoice.forEach(value => {
        if (value.fpje && value.fpje !== '') {
          je += Number(value.fpje).toFixed(2) * 100
        }
        if (value.se && value.se !== '') {
          se += Number(value.se).toFixed(2) * 100
        }
      })
      this.viewTemplate.invoiceTotalSe = Number(se / 100).toFixed(2)
      this.viewTemplate.invoiceTotalFpJe = Number(je / 100).toFixed(2)
      return ['', '合计', '', '', '', Number(je / 100).toFixed(2), '', Number(se / 100).toFixed(2)]

    },
    costOrderHtChange(val) {
      this.$set(val, 'hth', val.hth.trim())
      this.$post('/fesback/cost/findLaborCostByHt.z', { hth: val.hth }).then(res => {
        this.$set(val, 'lwcb', res.data)
      })
    },
    addDataArr(val) {
      if (val === 'invoice') {
        this.viewTemplate[val].push({ kmbm: '22210101', km: '应交税费_应交增值税_进项税额', sl: '0' })
      } else {
        this.viewTemplate[val].push({})
      }
    },
    delDataArr(refVal, arrVal) {
      const a = this.$refs[refVal].selection
      a.forEach(data => {
        this.viewTemplate[arrVal].splice(this.viewTemplate[arrVal].indexOf(data), 1)
      })
    },
    /*
    * 保存校验
    *   成本金额 + 税额 = 发票金额
    *   税额 = 发票金额 / （1+税率） * 税额
    *
    * */
    save() {
      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const je1 = Decimal.add(this.viewTemplate.costTotalJe, this.viewTemplate.invoiceTotalSe)
      const je2 = new Decimal(this.viewTemplate.invoiceTotalFpJe)
      if (!je2.equals(je1)) {
        this.$message.error('成本金额合计加税额合计不等于发票金额合计，请检查！！！')
        loading.close()
        return
      }
      const data = this.viewTemplate.data
      data.jez = Number(je2).toFixed(2)
      data.orderEntities = this.viewTemplate.cost
      data.invoiceEntities = this.viewTemplate.invoice
      data.creditEntities = this.viewTemplate.creditEntry
      if (data.creditEntities.length > 0) {
        let creditJe = new Decimal(0)
        data.creditEntities.forEach(val => {
          creditJe = Decimal.add(creditJe, val.je)
        })
        let invoiceJe = new Decimal(0)
        data.invoiceEntities.forEach(val => {
          invoiceJe = Decimal.add(invoiceJe, val.fpje)
        })
        if (!creditJe.equals(invoiceJe)) {
          this.$message.error('增值税发票总金额和贷方分录总金额不一致，请检查！！！')
          loading.close()
          return
        }
      }
      this.$post(this.saveUrl, data).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.viewTemplate.display = false
          this.queryBillData()
        } else {
          this.$message.error(res.message)
        }
        loading.close()
      })
    },
    changeUser1(event) {
      this.viewTemplate.data.jkr = event[0]
      this.viewTemplate.data.jkrxm = event[1]
      dataQuery.queryCostBill(this.viewTemplate.data.jkrxm)
    },
    changeCostBillArr(event) {
      this.viewTemplate.data.fybxd = event[0]
      this.viewTemplate.data.je = event[1]
      this.viewTemplate.dxJe = dataQuery.convertCurrency(event[1])
    },
    slChange(row) {
      const taxRate = this.viewTemplate.slArr.filter(value => value.value === row.sl)
      if (row.fpje && row.fpje !== '' && taxRate.length > 0) {
        const sl = Number(taxRate[0].label.split('%')[0])
        const taxAmount = Number(row.fpje / (sl + 100)) * sl
        this.$set(row, 'se', (taxAmount).toFixed(2))
      }
    },
    /* 文件导入 */
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    handleChange(files, fileListt) {
      if (files.name === fileListt[fileListt.length - 1]) {
        this.$refs.upload.clearFiles()
      }
      this.fileList = fileListt
      this.readExcel(files)
    },
    readExcel(file) {
      const fileReader = new FileReader()
      fileReader.onload = ev => {
        try {
          const data = ev.target.result
          const workbook = read(data, { type: 'binary' })
          const fileData = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
          this.viewTemplate.cost = []
          fileData.forEach(val => {
            const item = {
              status: 1
            }
            Object.keys(val).forEach(key => {
              if (key !== '序号') {
                const k = key.split('##')[1] + ''
                item[k] = val[key] + ''
              }
            })
            this.viewTemplate.cost.push(item)
          })
        } catch (e) {
          console.log('error:' + e)
        }
        return false
      }
      fileReader.readAsBinaryString(file.raw)
    }


  }
}
